import { combineReducers } from '@reduxjs/toolkit';

import isRefreshPageModalOpen from './isRefreshPageModalOpen';

/**
 * @typedef {{
 *   isRefreshPageModalOpen: import('./isRefreshPageModalOpen').IsRefreshPageModalOpenState,
 * }} ModalsState
 */

export default combineReducers({
  isRefreshPageModalOpen,
});
